import React from 'react';
import PaymentsTable from '../components/PaymentsTable';

const Payments = () => {
  return <PaymentsTable />;
};

export default Payments;
